let LineupResolvingProcess = {
    SET_LINEUP_RESOLVING_PROCESS_DATA: 'SET_LINEUP_RESOLVING_PROCESS_DATA',
};

export default LineupResolvingProcess;
